import { Component, OnInit } from "@angular/core";
import { NavigationService } from "../services/navigation.service";

@Component({
  selector: "ch-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  public showSidebar: boolean;
  public routes: Array<{
    route?: string;
    label: string;
    badge?: number;
    hide?: boolean;
    subRoutes?: Array<{ route: string; label: string }>;
  }>;

  constructor(private navigationService: NavigationService) {
    this.routes = [
      {
        route: "dashboard",
        label: "Dashboard",
      },
      {
        route: "members",
        label: "Members",
      },
      {
        route: "members-for-verification",
        label: "Pending Verification",
      },
      {
        route: "verification-codes",
        label: "Verification Codes",
      },
      {
        route: "offers",
        label: "Offers",
      },
      {
        route: "offer-redemptions",
        label: "Offer Redemptions",
      },
      {
        route: "membership-codes",
        label: "Promo Codes",
      },
      {
        route: "referral-programs",
        label: "Referral Programs",
      },
      {
        route: "admin-users",
        label: "Admin Users",
      },
      {
        route: "notifications",
        label: "Notifications",
      },
      {
        route: "subscription-plans",
        label: "Subscription Plans",
      },
      {
        route: "exit-survey",
        label: "Exit Survey",
      },
      {
        label: "Reference data",
        subRoutes: [
          {
            route: "offer-types",
            label: "Venue Types",
          },
          {
            route: "offer-tags",
            label: "Offer Tags",
          },
          {
            route: "employers",
            label: "Employers",
          },
          {
            route: "business-types",
            label: "Business Types",
          },
          {
            route: "business-classifications",
            label: "Business Classifications",
          },
          {
            route: "job-titles",
            label: "Job Titles",
          },
          {
            route: "management-levels",
            label: "Management Levels",
          },
          {
            route: "areas-of-business",
            label: "Areas of Business",
          },
          {
            route: "sponsors",
            label: "Sponsors",
          },
          {
            route: "whitelisted-domains",
            label: "Whitelisted Domains",
          },
          {
            route: "coupons",
            label: "Coupons",
          },
          {
            route: "emails",
            label: "Emails",
          },
          {
            route: "ab-tests",
            label: "AB Tests",
          },
        ],
      },
    ];

    navigationService.showSidebar.subscribe((show: boolean) => {
      this.showSidebar = show;
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/sidebar/sidebar.component.ts